
import React from 'react';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from './FontAwesomeIcon';
import NewsletterForm from './NewsletterForm';

export default function Footer() {
  return (
    <footer className="bg-safari-green text-white py-12 border-t border-safari-gold/20 prevent-horizontal-scroll">
      <div className="container mx-auto px-4 prevent-horizontal-scroll">
        {/* Newsletter Section */}
        <div className="mb-12 pb-12 border-b border-gray-700">
          <div className="max-w-2xl mx-auto text-center mb-6">
            <h3 className="text-2xl font-bold mb-2 text-safari-gold font-heading">
              Stay Updated with Safari News
            </h3>
            <p className="text-gray-300 mb-6">
              Get exclusive travel tips, special offers, and inspiring stories from Uganda
            </p>
            <NewsletterForm inline={true} />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Column 1: Help Center */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-safari-gold font-heading">Help Center</h3>
            <ul className="space-y-3">
              <li><Link to="/faqs" className="text-gray-300 hover:text-white transition-colors">FAQs</Link></li>
              <li><Link to="/travel-guide" className="text-gray-300 hover:text-white transition-colors">Travel Guide</Link></li>
              <li><Link to="/booking-terms" className="text-gray-300 hover:text-white transition-colors">Booking Terms</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/safety" className="text-gray-300 hover:text-white transition-colors">Safety Information</Link></li>
            </ul>
          </div>

          {/* Column 2: Extra Services */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-safari-gold font-heading">Extra Services</h3>
            <ul className="space-y-3">
              <li><Link to="/airport-transfers" className="text-gray-300 hover:text-white transition-colors">Airport Transfers</Link></li>
              <li><Link to="/accommodation-booking" className="text-gray-300 hover:text-white transition-colors">Accommodation Booking</Link></li>
              <li><Link to="/car-hire" className="text-gray-300 hover:text-white transition-colors">Car Hire</Link></li>
              <li><Link to="/visa-assistance" className="text-gray-300 hover:text-white transition-colors">Visa Assistance</Link></li>
              <li><Link to="/travel-insurance" className="text-gray-300 hover:text-white transition-colors">Travel Insurance</Link></li>
              <li><Link to="/custom-itineraries" className="text-gray-300 hover:text-white transition-colors">Custom Itineraries</Link></li>
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-safari-gold font-heading">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/destinations" className="text-gray-300 hover:text-white transition-colors">Destinations</Link></li>
              <li><Link to="/experiences" className="text-gray-300 hover:text-white transition-colors">Safari Packages</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-white transition-colors">Blog & News</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Column 4: Contact Information */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-safari-gold font-heading">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <FontAwesomeIcon icon="fa-envelope" className="w-5 h-5 text-safari-gold mt-1" />
                <div className="text-gray-300">
                  <a href="mailto:info@shakestravel.com" className="block hover:text-white transition-colors">info@shakestravel.com</a>
                  <a href="mailto:shakestravel23@gmail.com" className="block hover:text-white transition-colors">shakestravel23@gmail.com</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <FontAwesomeIcon icon="fa-phone" className="w-5 h-5 text-safari-gold mt-1" />
                <a href="tel:+256705718590" className="text-gray-300 hover:text-white transition-colors">+256-705718590</a>
              </div>
              <div className="flex items-start gap-3">
                <FontAwesomeIcon icon="fa-location-dot" className="w-5 h-5 text-safari-gold mt-1" />
                <span className="text-gray-300">Jinja and Kampala, Uganda</span>
              </div>

              {/* Social Media Icons */}
              <div className="pt-4 flex gap-4">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-safari-gold hover:text-safari-green transition-all duration-300">
                  <FontAwesomeIcon icon="fa-facebook" className="w-5 h-5" />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-safari-gold hover:text-safari-green transition-all duration-300">
                  <FontAwesomeIcon icon="fa-instagram" className="w-5 h-5" />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-safari-gold hover:text-safari-green transition-all duration-300">
                  <FontAwesomeIcon icon="fa-x-twitter" className="w-5 h-5" />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-safari-gold hover:text-safari-green transition-all duration-300">
                  <FontAwesomeIcon icon="fa-linkedin" className="w-5 h-5" />
                </a>
                <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-safari-gold hover:text-safari-green transition-all duration-300">
                  <FontAwesomeIcon icon="fa-tiktok" className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Shakes Travel. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/sitemap" className="hover:text-white transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
